import Vue from 'vue';

export function scrollToTop() {
    window.scrollTo(0, 0);
}
 

export function imgToSvg() {
    document.querySelectorAll('img.svg').forEach(el => {
        el.style.visibility = 'hidden';
        const imgID = el.getAttribute('id');
        const imgClass = el.getAttribute('class');
        const imgURL = el.getAttribute('src');

        fetch(imgURL)
            .then(data => data.text())
            .then(response => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(response, 'text/html');
                let svg = xmlDoc.querySelector('svg');

                if (typeof imgID !== 'undefined') {
                    svg.setAttribute('id', imgID);
                }

                if (typeof imgClass !== 'undefined') {
                    svg.setAttribute('class', imgClass + ' replaced-svg');
                }

                svg.removeAttribute('xmlns:a');

                if (el.parentNode) {
                    el.parentNode.replaceChild(svg, el);
                    el.style.visibility = 'initial';
                }
            });
    });
}

export function minHeightScreen() {
    var altura = window.innerHeight;
    var navbar = document.getElementById('navbar').offsetHeight;
    var footer = document.getElementById('footer').offsetHeight;

    document
        .querySelectorAll('.wrapper')
        .forEach(el => (el.style.minHeight = altura - navbar - footer + 'px'));
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function verificarObjetoCompleto(obj) {
    let flag = true;
 
    for (var key in obj) {
        if (obj[key] === null || obj[key] === '') {
            flag = false;
            return flag;
        }
    }
    return flag;
}

export function verificarObjetoPresentaValores(obj) {
    for (var key in obj) {
        if (obj[key] && key !== 'id') return true;
    }
    return false;
}

export function agregarScriptHeader(src) {
    let script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    script.id = 'recaptchaScript';
    script.src = src;

    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = function() {
        //document.getElementsByTagName('head')[0].appendChild(script)
    };
}

export function removeCaptchaBadge() {
    if (document.getElementById('recaptchaScript') != null) {
        document.getElementById('recaptchaScript').remove();
    }
    if (document.getElementsByClassName('grecaptcha-badge').length > 0) {
        document.getElementsByClassName('grecaptcha-badge')[0].remove();
    }
}

export function agregarScriptFooter(src) {
    //<script type="text/javascript" src="/olarkChat.js" async></script>
    let script = document.createElement('script');
    script.async = true;
    //script.setAttribute('defer', '');
    script.id = 'olarkChat';
    script.defer = true;
    script.src = src;
    document.getElementsByTagName('footer')[0].appendChild(script);
    script.onload = function() {
        //olark('api.box.hide');
    };
}


export function notificationSticky() {
    var aviso = document.getElementById('aviso');
    var header = document.getElementById('navbar').offsetHeight;
    var sticky = aviso.offsetTop;

    window.onscroll = function() {
        if (window.pageYOffset > header) {
            aviso.classList.add('sticky');
        } else {
            aviso.classList.remove('sticky');
        }
    };
}

export const formatInt = int => {
    if (int < 10) {
        return `0${int}`;
    }
    return `${int}`;
};

export function getParameterByName(name, url) {
    
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&'); //eslint-disable-line
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function isNumberWithDot(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
    } else {
        return true;
    }
}

export function isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
    } else {
        return true;
    }
}
 
